import { GET_PHARMACEUTICAL_UNITS_LIST_SUCCESS, GET_PHARMACEUTICAL_UNITS_LIST_ERROR } from '../../actionType';

import { pharmaceutical } from '../api';

export const successGetPharmaceuticalUnitsList = payload => ({
	type: GET_PHARMACEUTICAL_UNITS_LIST_SUCCESS,
	payload
});

export const errorGetPharmaceuticalUnitsList = payload => ({
	type: GET_PHARMACEUTICAL_UNITS_LIST_ERROR,
	payload
});

export const getPharmaceuticalUnitsList = () => async (dispatch) => {
	try {
	  const response = await pharmaceutical.getPharmaceuticalUnitsList();

	  if (response.status === 200) {
		dispatch(successGetPharmaceuticalUnitsList(response.data));
	  } else {
		dispatch(errorGetPharmaceuticalUnitsList(response.data));
	  }
	} catch (error) {
	  console.error("Erro ao tentar obter lista de unidades:", error);
	  dispatch(errorGetPharmaceuticalUnitsList(error));
	}
  };
